import Localize from "../i18n";
function initializeI18n() {
    Localize.init();
}
initializeI18n();
export default Localize;
